import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function websiteUrlValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const {value} = control;

    if (!value) {
      return null;
    }

    const pattern =
      /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)?$/;

    return value.match(pattern) ? null : {invalidWebsiteUrl: true};
  };
}
